import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=4b5fae89"
import script from "./UserUpdate.vue?vue&type=script&lang=js"
export * from "./UserUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports